import { BaseEndpoint, BaseSDK } from '@livefree/js-sdk';

class PasswordEndpoint extends BaseEndpoint {
  constructor(config) {
    super('api/v1/password', config);
    this.config = config;
  }

  info(token) {
    const url = super.appendUrl('/info/{token}');
    return super.httpGET({ url, params: { token } });
  }

  setPassword(token, password) {
    const url = super.appendUrl('/');
    return super.httpPUT({ url, body: { token, password } });
  }
}

export class PasswordClient extends BaseSDK {
  #password_endpoint;
  constructor(baseUrl) {
    super(baseUrl);
    this.#password_endpoint = new PasswordEndpoint(this.config);
  }

  info(token) {
    return this.#password_endpoint.info(token);
  }

  setPassword(token, password) {
    return this.#password_endpoint.setPassword(token, password);
  }
}
